
import React from 'react';
import { Table, TableBody } from '@/components/ui/table';
import { ReportTableRow } from './ReportTableRow';
import { ReportTableHeader } from './ReportTableHeader';
import { Report } from '@/types/report';

interface ReportsListProps {
  reports: Report[];
  formatDate: (date: string | null) => string;
  formatTime: (time: string | null) => string;
  showAdminColumns?: boolean;
  showTeacherDisplay?: boolean;
  sortField: string;
  sortDirection: 'asc' | 'desc';
  onSort: (field: string) => void;
  onReportUpdate?: () => void; // Added optional onReportUpdate prop
}

export const ReportsList: React.FC<ReportsListProps> = ({
  reports,
  formatDate,
  formatTime,
  showAdminColumns = false,
  showTeacherDisplay = false,
  sortField,
  sortDirection,
  onSort,
  onReportUpdate // Added prop
}) => {
  return (
    <div className="rounded-lg border overflow-hidden">
      <Table>
        <ReportTableHeader 
          showTeacherDisplay={showTeacherDisplay} 
          showAdminColumns={showAdminColumns}
          sortField={sortField}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <TableBody>
          {reports.map((report) => (
            <ReportTableRow
              key={report.id}
              report={report}
              formatDate={formatDate}
              formatTime={formatTime}
              showTeacherDisplay={showTeacherDisplay}
              showAdminColumns={showAdminColumns}
              onReportUpdate={onReportUpdate} // Pass prop to row component if available
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
